import { c as _c } from "react/compiler-runtime";
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { NavLink } from '@sola/ark-core/atoms/link/nav-link.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { NavigationProps } from '@sola/schema/lib/schema.ts';
import { trackClick } from '@sola/tracking/lib/analytics/events.ts';
import { NavSheet } from '../../molecules/nav-sheet/nav-sheet.tsx';
import { getMenuItemColumns } from '../../utils/nav-utils.ts';
type DesktopMenuItemProps = {
  item: NavigationProps;
  menuOpen: string;
  handleTriggerEnter: (itemTitle: string) => void;
  handleTriggerLeave: (e?: React.PointerEvent) => void;
  handleContentEnter: () => void;
  handleContentLeave: () => void;
  setActiveItem: (item: string) => void;
};
export const DesktopMenuItem: React.FC<DesktopMenuItemProps> = t0 => {
  const $ = _c(42);
  const {
    item,
    menuOpen,
    handleTriggerEnter,
    handleTriggerLeave,
    handleContentEnter,
    handleContentLeave,
    setActiveItem
  } = t0;
  const hasChildren = Boolean(item.items?.length);
  let t1;
  if ($[0] !== handleContentEnter || $[1] !== handleContentLeave || $[2] !== handleTriggerEnter || $[3] !== handleTriggerLeave || $[4] !== hasChildren || $[5] !== item || $[6] !== menuOpen || $[7] !== setActiveItem) {
    const columns = getMenuItemColumns(item);
    const t2 = item.title;
    const t3 = item.title;
    let t4;
    if ($[9] !== handleTriggerEnter || $[10] !== item.title) {
      t4 = () => item.title && handleTriggerEnter(item.title);
      $[9] = handleTriggerEnter;
      $[10] = item.title;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== handleTriggerEnter || $[13] !== hasChildren || $[14] !== item.title || $[15] !== menuOpen) {
      t5 = () => {
        if (menuOpen && item.title && hasChildren) {
          handleTriggerEnter(item.title);
        }
      };
      $[12] = handleTriggerEnter;
      $[13] = hasChildren;
      $[14] = item.title;
      $[15] = menuOpen;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== handleTriggerLeave || $[18] !== hasChildren || $[19] !== menuOpen) {
      t6 = () => {
        if (menuOpen && hasChildren) {
          handleTriggerLeave();
        }
      };
      $[17] = handleTriggerLeave;
      $[18] = hasChildren;
      $[19] = menuOpen;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    let t7;
    if ($[21] !== hasChildren || $[22] !== item.link || $[23] !== item.title || $[24] !== menuOpen || $[25] !== setActiveItem) {
      t7 = e_0 => {
        if (!item.title) {
          return;
        }
        trackClick(item.title, item?.link || "#", "Header__trigger");
        if (!hasChildren) {
          return;
        }
        if (menuOpen && e_0.detail !== 0) {
          e_0.preventDefault();
        }
        if (e_0.detail === 0) {
          if (menuOpen === item.title) {
            setActiveItem("");
          } else {
            setActiveItem(item.title);
          }
        } else {
          if (menuOpen !== item.title) {
            setActiveItem(item.title);
          }
        }
      };
      $[21] = hasChildren;
      $[22] = item.link;
      $[23] = item.title;
      $[24] = menuOpen;
      $[25] = setActiveItem;
      $[26] = t7;
    } else {
      t7 = $[26];
    }
    const t8 = menuOpen === item.title;
    let t9;
    if ($[27] !== t8) {
      t9 = cn("Header__trigger flex items-center justify-between", {
        "Header__trigger--active": t8
      });
      $[27] = t8;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    let t10;
    if ($[29] !== hasChildren || $[30] !== item.link || $[31] !== item.target || $[32] !== item.title) {
      t10 = hasChildren ? <button type="button"><p className="label label-potent label-neutral flex items-center gap-snug-md">{item.title}<ArkIcon iconName="chevron-down" className="Header__chevron" /></p></button> : <NavLink href={item?.link || "#"} title={item?.title} target={item?.target} className="Header__desktop-nav-item label label-potent label-neutral">{item.title}</NavLink>;
      $[29] = hasChildren;
      $[30] = item.link;
      $[31] = item.target;
      $[32] = item.title;
      $[33] = t10;
    } else {
      t10 = $[33];
    }
    let t11;
    if ($[34] !== handleTriggerLeave || $[35] !== t10 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6 || $[39] !== t7 || $[40] !== t9) {
      t11 = <NavigationMenu.Trigger onTouchEnd={_temp} onPointerEnter={t4} onPointerLeave={handleTriggerLeave} onFocus={t5} onBlur={t6} onClick={t7} className={t9} asChild={true}>{t10}</NavigationMenu.Trigger>;
      $[34] = handleTriggerLeave;
      $[35] = t10;
      $[36] = t4;
      $[37] = t5;
      $[38] = t6;
      $[39] = t7;
      $[40] = t9;
      $[41] = t11;
    } else {
      t11 = $[41];
    }
    t1 = <NavigationMenu.Item value={t2} key={t3} className="flex justify-center">{t11}{hasChildren && <NavigationMenu.Content className="Header__content Header__container flex justify-center" onPointerEnter={handleContentEnter} onPointerLeave={handleContentLeave} onFocus={handleContentEnter} onBlur={handleContentLeave}><div className="w-full max-w-xl flex flex-col"><div className="pt-roomy-xs pb-comfy-lg"><div className="Header__link-container pb-snug-md"><LinkStyle noPadding={true} noUnderline={true} size="lg" iconAfter="arrow-right"><Link href={item?.link || "#"} target={item?.target} title={item?.title}>{item.title}</Link></LinkStyle></div></div><div className="Header__navsheet-container gap-comfy-xl pb-comfy-xl pt-comfy-xs">{item.featuredArticles ? <><NavSheet key={columns[0].map(_temp2).join(",")} items={columns[0]} /><NavSheet key="featuredReads" featuredArticles={true} items={[]} /><NavSheet key={columns[1].map(_temp3).join(",")} items={columns[1]} cta={item.cta} /></> : columns.map((col, idx) => <NavSheet key={col.map(_temp4).join(",")} items={col} {...idx === 2 ? {
              cta: item.cta
            } : {}} />)}</div></div></NavigationMenu.Content>}</NavigationMenu.Item>;
    $[0] = handleContentEnter;
    $[1] = handleContentLeave;
    $[2] = handleTriggerEnter;
    $[3] = handleTriggerLeave;
    $[4] = hasChildren;
    $[5] = item;
    $[6] = menuOpen;
    $[7] = setActiveItem;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
function _temp(e) {
  return e.preventDefault();
}
function _temp2(ci) {
  return ci.title;
}
function _temp3(ci_0) {
  return ci_0.title;
}
function _temp4(ci_1) {
  return ci_1.title;
}